<template>
  <div class="upload">
    <div
      class="btn"
      v-show="urls.length === 0">
      <input
        type="hidden"
        :id="id"
        :name="name"
        v-model="data" />
      <input
        type="file"
        ref="input" />
      <div class="btn">
        <i class="iconfont">&#xe641;</i>
        <span>上传图片</span>
      </div>
    </div>
    <div class="desc">
      只支持PNG,jpg格式,最大1M。
    </div>
  </div>
</template>

<script>
import Schema from 'async-validator';
import {imgUpload} from '@/service';

export default {
  name: 'AuthFormUpload',
  props: {
    rule: {
      type: Array,
      default: () => [],
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: [Array],
    maxFile: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      data: '',
      validator: null,
      urls: [],
    };
  },
  watch: {
    value(n, o) {
      const newVal = JSON.stringify(n);
      const oldVal = JSON.stringify(o);
      if (newVal === oldVal) return;
      this.data = n;
      if (this.value !== '') {
        this.urls = this.value.split(',');
      }
    },
  },
  methods: {
    validate() {
      return new Promise((resolve, reject) => {
        new Schema({
          value: this.rule,
        }).validate({value: this.data}, (err) => {
          if (err) {
            reject(err[0].message);
          } else {
            resolve();
          }
        });
      });
    },
    removeImage() {
      this.urls = [];
      this.data = '';
      this.$emit('input', this.data);
    },
    readFile() {
      const $this = this;
      const input = this.$refs['input'];
      const file = input.files[0];
      const reader = new FileReader();
      reader.onload = function(event) {
        const formData = new FormData();
        formData.append('file', file);
        imgUpload(formData).then(({url}) => {
          $this.urls.push(url);
          $this.data = $this.urls.join(',');
          $this.$emit('input', $this.data);
        }).finally(() => {
          input.value = '';
        });
      };
      reader.readAsText(file);
    },
    addFileEvent() {
      const input = this.$refs['input'];
      input.addEventListener('change', this.readFile, false);
    },
    removeFileEvent() {
      const input = this.$refs['input'];
      input.removeEventListener('change', this.readFile);
    },
  },
  mounted() {
    this.addFileEvent();
  },
  beforeDestroy() {
    this.removeFileEvent();
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  margin-bottom: 20px;
  .label {
    line-height: 16px;
    color: rgba(0, 0, 0, 0.65);
    font-size: 12px;
    width: 100%;
    span {
      color: #fd5959;
    }
  }
  .disabled {
    background: rgba(0, 0, 0, 0.04);
  }
  input {
    outline: 0;
    width: 100%;
    display: block;
    height: 32px;
    font-size: 12px;
    background: white;
    border-radius: 4px;
    padding: 0 6px;
    margin-top: 8px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
    transition: all ease-in 200ms;
    color: rgba(0, 0, 0, 0.65);
  }
  &.input-error {
    input {
      border-color: #fd5959;
      box-shadow: 0 0 3px 0 #fd5959;
    }
  }
  .upload-wrap {
    width: 100%;
    margin: 8px;
    .upload {
      position: relative;
      overflow: hidden;
      .img {
        width: 104px;
        height: 104px;
        border-radius: 3px;
        overflow: hidden;
        position: relative;
        margin-right: 8px;
        img {
          display: block;
          width: 100%;
          height: 100%;
        }
        i {
          position: absolute;
          top: 0;
          right: 0;
          background: #f7f7f7;
          width: 16px;
          height: 16px;
          line-height: 16px;
          opacity: 0.8;
          cursor: pointer;
          &:hover {
            opacity: 1;
          }
        }
      }
      .btn {
        user-select: none;
        cursor: pointer;
        transition: all 0.2s;
        width: 104px;
        height: 104px;
        background: rgba(0, 0, 0, 0.02);
        border-radius: 4px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        overflow: hidden;
        position: relative;
        float: left;

        &:hover {
          opacity: 0.8;
        }
        i {
          color: rgba(0, 0, 0, 0.45);
        }
        span {
          color: rgba(0, 0, 0, 0.45);
          font-size: 12px;
        }
      }
      .desc {
        color: rgba(0, 0, 0, 0.45);
        font-size: 12px;
        margin-top: 8px;
      }
    }
  }
  .image-captcha {
    position: relative;
    width: 100%;
    img {
      position: absolute;
      top: 13px;
      right: 6px;
      border-radius: 3px;
    }
  }
  .sms-button {
    position: relative;
    width: 100%;
    .btn {
      position: absolute;
      top: 13px;
      right: 6px;
      color: #fff;
      background: #1890ff;
      border-radius: 4px;
      border: 0;
      padding: 3px 6px;
      font-size: 12px;
      text-align: center;
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
      &.disabled {
        background: #f7f7f7;
        color: #ccc;
        cursor: default;
      }
    }
  }
}
</style>
